import { ApiRequest } from "./base";

const apiRoute = "page";

export const StaticApi = {
	async getInfo(id) {
		return ApiRequest(`${apiRoute}/${id}`, "GET");
	},
};
